import React from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../Component/layout.css";

import logo from "../../src/assests/vhs-lgo.png"; 
import bgwinter from "../../src/assests/navbar_winter1.png"; 

function Homenavbar() {
  const userDataString = localStorage.getItem("user");
  let userData = null; // Initialize userData as null

  // Check if userDataString exists AND is not the literal string "undefined"
  if (userDataString && userDataString !== "undefined") {
    try {
      userData = JSON.parse(userDataString); // Try parsing only if it's a potentially valid string
    } catch (error) {
      console.error("Error parsing user data from localStorage in Navbar:", error);
      // If parsing fails (e.g., malformed JSON), clear the invalid item and keep userData null
      localStorage.removeItem("user");
      userData = null;
    }
  }
  const navigate = useNavigate();
  const location = useLocation();
  

  const handleremove = () => {
    localStorage.removeItem("user");
    if (location.state?.from) {
      navigate(location.state.from); // Navigate to the previous page if it exists
    } else {
      navigate('/', { state: { from: location.pathname } });
    }
  };

  return (
    <div
      className="d-flex navbar-cart"
      style={{
       backgroundImage: `url(${bgwinter})`, // Set the background image
        backgroundSize: "cover", // Cover the entire div
        padding: "15px",
        justifyContent: "space-between",
        
        
      }}
    >
      <div className="col-md-10">
        <a href="/" style={{ textDecoration: "none" }}>
          <img
            src= {logo}
            alt=""
            width={40}
            height={40}
          />
          <span
            className=" "
            style={{
              color: "black",
              fontSize: "18px",
              fontWeight: "bold",
              textAlign: "left",
              marginTop: "30px",
              marginLeft: "15px"
            }}
          >
            VHS
          </span>
        </a>
      </div>
      <div
        className="col-md-2 d-flex"
        style={{ justifyContent: "center", alignItems: "center" }}
      >
        {userData !== null && userData !== undefined ? (
          <div className="d-flex">
            <Dropdown>
              <Dropdown.Toggle
                style={{
                  display: "flex",
                  justifyContent: "end",
                  padding: "0px",
                  border: "none",
                }}
                variant=""
                id="dropdown-basic"
              >
                <i
                  className="fa-solid fa-user mt-1"
                  style={{ fontSize: "15px", color: "black" }}
                ></i>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  className="dropdown-item poppins-regular"
                  style={{ fontSize: "12px" }}
                  href="/mybooking"
                >
                  My Bookings
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={handleremove}
                  className="poppins-regular dropdown-item"
                  style={{ fontSize: "12px" }}
                  href="#/action-3"
                >
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <span className="poppins-black mx-1" style={{ color: "black", fontSize: "12px" }}>
              {userData?.customerName}
            </span>
          </div>
        ) : (
          <Link className="mx-2" to="/login" style={{ textDecoration: "none" }}>
            <div
              className="poppins-black mx-1"
              style={{ color: "black", fontSize: "12px" }}
            >
              Login / Signup
            </div>
          </Link>
        )}
      </div>
    </div>
  );
}

export default Homenavbar;